const ApHome = () => {
  return (
    <div className="w-full h-full flex items-center justify-center text-3xl font-bold">
      Accountability Partner Placeholder
    </div>
  );
};

export default ApHome;
